import { supportedLocales, type Locale } from '@/lib/i18n';

export type LocaleCode = (typeof supportedLocales)[number]['code'];

/** All UI language-switcher options (en, de, bg). */
export function getLocaleOptions(): Locale[] {
  return supportedLocales;
}

export function getLocaleOption(code: string): Locale | undefined {
  return supportedLocales.find(locale => locale.code === code);
}

export function isLocaleCode(code: string): code is LocaleCode {
  return supportedLocales.some(locale => locale.code === code);
}
